import { put, call, takeEvery } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Lesson } from '../types'
import { FETCH_LESSON, FETCH_LESSON_SUCCESS, FETCH_LESSON_FAIL, FetchLessonAction } from '../redux/lessonReducer'

function* FetchLessonFlow(action: FetchLessonAction): Generator<any, void, any> {
  try {
    const response: Lesson = yield call(apiCall, {
      endpoint: `/tutors/lessons/${action.payload.id}`,
      method: 'GET',
      params: {}
    })
    yield put(FETCH_LESSON_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_LESSON_FAIL())
    console.log(error)
  }
}

export default function* FetchLessonSaga(): Generator<any, void, any> {
  yield takeEvery([FETCH_LESSON], FetchLessonFlow)
}
